import { Button, CircularProgress } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { producaov2 } from "../../../../services/apis";
import { PROJECT_APPLICATIONS_STATUS } from "../hooks/useProjectApplications";

export default function CertificateButton({ applicationID, defaultCertificateUrl, status }) {
  const [certificateUrl, setCertificateUrl] = useState(defaultCertificateUrl);
  const [loading, setLoading] = useState(false);

  const handleCreateCertificate = async () => {
    setLoading(true);

    try {
      const response = await producaov2.post(`/admin/project-applications/${applicationID}/certificate`);

      setCertificateUrl(response.data?.url);

      toast.success('Certificado gerado com sucesso');
    } catch (error) {
      toast.error('Houve um erro ao gerar o certificado');
    } finally {
      setLoading(false);
    }
  }

  const disabledCertificate = loading || ![PROJECT_APPLICATIONS_STATUS.APPROVED, PROJECT_APPLICATIONS_STATUS.FINISHED].includes(+status);

  return certificateUrl ? (
    <Button
      title="Visualizar certificado"
      size="small"
      variant="text"
      color="primary"
      component="a"
      href={certificateUrl}
      target="_blank"
      startIcon={<Visibility />}
    >
      VISUALIZAR
    </Button>
  ) : (
    <Button
      title={disabledCertificate ? "Projeto precisa estar aprovado para gerar certificado" : "Emitir certificado"}
      size="small"
      variant="outlined"
      color="primary"
      disabled={disabledCertificate}
      onClick={handleCreateCertificate}
    >
      {loading ? <CircularProgress size={16} /> : "EMITIR"}
    </Button>
  );
}
